import { useOutletContext } from 'react-router-dom';

import type { ClinicAccessState } from '../lib/clinic-access';

/** What the clinic frame tells its tabs. Ids and access state only. */
export interface ClinicFrameContext {
  tenantId: string;
  access: Extract<ClinicAccessState, 'own' | 'granted' | 'needs-grant'>;
  /** A System Admin's own tenant: the platform. */
  isPlatform: boolean;
}

export function useClinicFrame(): ClinicFrameContext {
  return useOutletContext<ClinicFrameContext>();
}
